// -------------------------------------------------------------------------------- //

import { ICAMSKey, FeatureType, IMapInteractionConfig } from "./UtilityModels";
import { Feature } from "ol";
import GeometryType from "ol/geom/GeometryType";
import { OptionalTracingLayer } from "../Map/MainMap";
import VectorLayer from "ol/layer/Vector";

// ENUMS
export enum MapLayerGroupType {
    Maint,
    MyMaint,
    Infra,
    Route,
    Land,
    User,
    Annotation,
    TRO,
    InfraHistoric,
    LegalRoute,
    LegalFeature
}

export interface LegendStyle {
    legendName: string;
    legendAltName?: string;
    style: string;
}

export enum BaseLayerType {
    TiledWMS,
    OSM,
    Bing,
    TileXYZ
}

export enum AdditionalMapLayerType {
    ImageWMS,
    TileArcGISRest,
    GeoJSON
}

// -------------------------------------------------------------------------------- //
// BASE LAYERS
export interface BaseLayerConfig {
    displayName: string;
    displayAltName?: string;
    baseURLs?: Array<string>;
    params?: any;
    minZoom: Number,
    opacity: number,
    baseLayerType: BaseLayerType,
    enabled: boolean;
    visibleOnStartup: boolean;
    attribution?: string;
    authPolicies?: Array<string>;
}

// -------------------------------------------------------------------------------- //
// VECTOR LAYERS
export interface CoreLayerConfig {
    layerID: string;
    wfsPointName: string;
    wfsLineName: string;
    wfsPolyName: string;
    visibleOnStartup: boolean;
    wfsName: string;
    minZoom: Number;
    mapLayerGroupType: MapLayerGroupType;
    legendStyle: LegendStyle;
    authPolicies?: Array<string>;
    enabled: boolean;
    symbologyKey?: string;
    onlyShowIfUserIsAnonymous?: boolean;

    legendName?: string;
    symbologyItem?: Array<SymbologyItem>;
    layerGroupName?: string;
    layerGroupNameAltName?: string;
    olLayers?: Array<VectorLayer>;
}

export interface SymbologyItem {
    wfsAttributeName: string;
    attributeLabel: string;
    attributeAltLabel?: string;
    attributeValue: string;
    showInLegend: Boolean;
    image?: { imageSource: string; }
    stroke?: { strokeColor?: string, width?: number; lineDash?: string; fillColor?: string;}
}

export interface AdditionalLayerConfig {
    visibleOnStartup: boolean;
    canInfoClick: boolean;
    params: string;
    baseURL: string;
    additionalMapLayerType: AdditionalMapLayerType;
    enabled: Boolean;
    minZoom: Number;
    mapLayerGroupType: MapLayerGroupType;
    legendStyle: LegendStyle;
    authPolicies?: Array<string>;
    layerGroupName?: string;
    layerGroupNameAltName?: string;
}

export interface GridLayerConfig {
    visibleOnStartup: boolean;
    enabled: Boolean;
}

// -------------------------------------------------------------------------------- //
// MAP INITIAL STATE
export interface MapInitialState {
    zoom: number;
    center: Array<Number>;
    minZoom: number;
    maxZoom: number;
    selectHitTolerance: Number;
    mapBaseProjection: string;
}

// -------------------------------------------------------------------------------- //
// MAIN CLASS
export interface MapConfigModel {
    version: number;
    contactRef: string;
    coreLayers: Array<CoreLayerConfig>;
    additionalLayers: Array<AdditionalLayerConfig>;
    gridLayer: GridLayerConfig;
    baseLayers: Array<BaseLayerConfig>;
    mapInitialState: MapInitialState;
    createEntityMaxDistanceAway?: number;
}

// -------------------------------------------------------------------------------- //
// MAP STYLES
export interface IStyleCache {
    wfsAttributeName?: string;
    attributeValue: string;
    attributeLabel: string;
    attributeAltLabel?: string;
    style: any;
    showInLegend?: Boolean;
    symbologyKey?: string;
}

// -------------------------------------------------------------------------------- //
// NEW GEOMETRY CONFIG
export interface INewGeometryConfig {
    data?: ICAMSKey;
    featureType: FeatureType;
    featureSelected?: Feature;
    interactionData?: IMapInteractionConfig;
    skipStep2withGeom?: GeometryType;
    createEntityMaxDistanceAway?: number;
    tracingLayer?: OptionalTracingLayer;
}


